import PropTypes from 'prop-types'

/**
 * @typedef {Object} TpmsIssues
 * @property {number}   [issuesCount] - Total number of TMPS issues.
 * @property {Id}       objectId      - The ID of the object.
 * @property {string}   [topSeverity] - Top severity.
 */
export const vehicleTpmsIssuesPropType = PropTypes.shape({
    issueCount: PropTypes.number,
    objectId: PropTypes.string.isRequired,
    topSeverity: PropTypes.string
})
